import { render, staticRenderFns } from "./InvoiceCollapse.vue?vue&type=template&id=47d208b8&scoped=true&"
import script from "./InvoiceCollapse.vue?vue&type=script&lang=ts&"
export * from "./InvoiceCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceCollapse.vue?vue&type=style&index=0&id=47d208b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d208b8",
  null
  
)

export default component.exports